module.exports = __webpack_public_path__ + "img/notification-success.c237c582.svg";